import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import "@/styles/HeroSection.css";

const slides = [
  {
    id: 1,
    title: "Construyendo el Futuro",
    subtitle: "Excelencia técnica y compromiso en cada proyecto",
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1920&q=80",
    cta: "Ver Proyectos"
  },
  {
    id: 2,
    title: "Calidad visible, compromiso real.",
    subtitle: "Más de 4 años transformando espacios en República Dominicana",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1920&q=80",
    cta: "Conoce Más"
  },
  {
    id: 3,
    title: "Tu Visión, Nuestra Misión",
    subtitle: "Residencial, comercial e institucional",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80",
    cta: "Contáctanos"
  }
];

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="hero-section" data-testid="hero-section">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`hero-slide ${index === currentSlide ? "active" : ""}`}
          style={{ backgroundImage: `url(${slide.image})` }}
          data-testid={`hero-slide-${index}`}
        >
          <div className="hero-overlay"></div>
        </div>
      ))}

      <div className="hero-content container">
        <div className="hero-text">
          <h1 className="hero-title" data-testid="hero-title">
            {slides[currentSlide].title}
          </h1>
          <p className="hero-subtitle" data-testid="hero-subtitle">
            {slides[currentSlide].subtitle}
          </p>
          <Link 
            to="/contacto" 
            className="hero-cta"
            data-testid="hero-cta-btn"
          >
            {slides[currentSlide].cta}
          </Link>
        </div>
      </div>

      <button 
        className="hero-nav prev" 
        onClick={prevSlide}
        aria-label="Previous slide"
        data-testid="hero-prev-btn"
      >
        <ChevronLeft size={32} />
      </button>
      <button 
        className="hero-nav next" 
        onClick={nextSlide}
        aria-label="Next slide"
        data-testid="hero-next-btn"
      >
        <ChevronRight size={32} />
      </button>

      <div className="hero-indicators" data-testid="hero-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
            data-testid={`hero-indicator-${index}`}
          >
          </button>
        ))}
      </div>
    </section>
  );
};

export default HeroSection;